import React, { useContext } from 'react';

// Profil (users/{uid}) de l'utilisateur connecté :
//   undefined = en cours de chargement, null = aucune fiche (accès refusé par les règles), objet sinon.
export const ProfileContext = React.createContext(undefined);
export const useProfile = () => useContext(ProfileContext);
